<template>
  <div>
    <h2>Configuration</h2>

     <b-toast title="Barcode Saved" static no-auto-hide>
       Successfully saved barcode prefix
    </b-toast>

    <b-row>
      <b-col cols="4" xl="3" sm="4">
        <b-alert :show="error" variant="danger">{{ error }}</b-alert>
        <label>Barcode Prefix</label>
        <b-form-input type="text" v-model="barcodePrefix" pattern="\d*" maxlength="1" />
        <b-button class="save-configuration-button" variant="secondary" :disabled="isLoading" @click="saveBarcodePrefix">
          <icon v-if="isLoading" scale="1"  name="spinner" spin class="clip-loader"></icon>
          <span v-else>Save</span>
        </b-button>
      </b-col>
    </b-row>
  </div> 
</template>

<script>
import api from '../api';


export default {
  data() {
    return {
      barcodePrefix: null,
      isLoading: false,
      error: null 
    };
  },
  async mounted() {
    const res = await api.getBarcodePrefix();
    const barcodePrefix = res.data.ret_msg.barcodePrefix;
    this.barcodePrefix = barcodePrefix;
  },
  methods: {
    async saveBarcodePrefix() {
      this.error = null;
      if (!this.barcodePrefix) {
        this.error = "Prefix needs to be a number between 1 - 9";
        return;
      }

      try {
        this.isLoading = true;
        await api.saveBarcodePrefix(this.barcodePrefix);
        this.isLoading = false;

        this.$bvToast.toast('Barcode prefix has successfully been changed', {
          title: "Barcode Prefix Changed",
          variant: "success",
          solid: true
        });
      } catch (e) {
        console.log(e);
        this.isLoading = false;
        this.error = "An unknown error occurred";
      }
    }
  }
}
</script>

<style lang="css" scoped>
.save-configuration-button {
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/Configuration.vue